import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const seoData = {
  '/': {
    title: 'ELC Teknoloji | IT & OT Siber Güvenlik Çözümleri',
    description: 'ELC Teknoloji - Türkiye\'nin IT ve OT siber güvenlik çözümleri partneri. ThreatLocker, Zebra Technologies, Fortinet, Active@ KillDisk yetkili bayisi.',
    canonical: 'https://elcteknoloji.com/'
  },
  '/cozumler': {
    title: 'Kurumsal Ağ ve Endpoint Güvenlik Hizmetleri | ELC Teknoloji',
    description: 'Firewall yönetimi, SIEM/SOC izleme, EDR/XDR endpoint koruması, sızma testleri ve OT güvenlik danışmanlığı. Türkiye genelinde 7/24 destek.',
    canonical: 'https://elcteknoloji.com/cozumler'
  },
  '/profesyonel-hizmetler': {
    title: 'Profesyonel IT Hizmetleri | ELC Teknoloji',
    description: 'Kurumsal IT danışmanlık, sistem entegrasyonu, ağ altyapısı kurulumu, güvenlik denetimi ve teknik destek hizmetleri.',
    canonical: 'https://elcteknoloji.com/profesyonel-hizmetler'
  },
  '/guvenlik-urunleri': {
    title: 'Kurumsal Güvenlik Ürünleri | ELC Teknoloji',
    description: 'Fortinet, ThreatLocker, Check Point, Active@ KillDisk ve daha fazlası. Kurumsal siber güvenlik ürünleri ve çözümleri.',
    canonical: 'https://elcteknoloji.com/guvenlik-urunleri'
  },
  '/zebra-urunleri': {
    title: 'Zebra Yazıcı ve Barkod Ürünleri | ELC Teknoloji',
    description: 'Zebra Technologies yetkili satış partneri. Barkod yazıcılar, el terminalleri, RFID çözümleri, endüstriyel ve mobil yazıcılar.',
    canonical: 'https://elcteknoloji.com/zebra-urunleri'
  },
  '/zebra-urunleri/endustriyel-yazicilar': {
    title: 'Zebra Endüstriyel Yazıcılar | ELC Teknoloji',
    description: 'Zebra endüstriyel barkod yazıcılar. ZT411, ZT421, ZT610, ZT620 ve daha fazlası. Yüksek hacimli etiket basımı için profesyonel çözümler.',
    canonical: 'https://elcteknoloji.com/zebra-urunleri/endustriyel-yazicilar'
  },
  '/zebra-urunleri/masaustu-yazicilar': {
    title: 'Zebra Masaüstü Yazıcılar | ELC Teknoloji',
    description: 'Zebra masaüstü barkod yazıcılar. ZD220, ZD421, ZD621 serisi. Ofis ve perakende için kompakt etiket yazıcılar.',
    canonical: 'https://elcteknoloji.com/zebra-urunleri/masaustu-yazicilar'
  },
  '/zebra-urunleri/mobil-yazicilar': {
    title: 'Zebra Mobil Yazıcılar | ELC Teknoloji',
    description: 'Zebra mobil ve taşınabilir yazıcılar. ZQ220, ZQ320, ZQ520, ZQ630 serisi. Saha operasyonları için portatif etiket yazıcılar.',
    canonical: 'https://elcteknoloji.com/zebra-urunleri/mobil-yazicilar'
  },
  '/zebra-urunleri/kart-yazicilar': {
    title: 'Zebra Kart Yazıcılar | ELC Teknoloji',
    description: 'Zebra plastik kart yazıcılar. ZC100, ZC300, ZXP serisi. Kimlik kartı, üyelik kartı ve akıllı kart basımı için çözümler.',
    canonical: 'https://elcteknoloji.com/zebra-urunleri/kart-yazicilar'
  },
  '/zebra-urunleri/barkod-okuyucular': {
    title: 'Zebra Barkod Okuyucular | ELC Teknoloji',
    description: 'Zebra barkod okuyucular ve tarayıcılar. DS2208, DS3608, DS8178 serisi. Perakende, depo ve endüstriyel kullanım için.',
    canonical: 'https://elcteknoloji.com/zebra-urunleri/barkod-okuyucular'
  },
  '/zebra-urunleri/giyilebilir-urunler': {
    title: 'Zebra Giyilebilir Ürünler | ELC Teknoloji',
    description: 'Zebra giyilebilir bilgisayarlar ve el terminalleri. WS50, WT6300 serisi. Depo ve lojistik operasyonları için hands-free çözümler.',
    canonical: 'https://elcteknoloji.com/zebra-urunleri/giyilebilir-urunler'
  },
  '/threatlocker-turkiye': {
    title: 'ThreatLocker Türkiye | ELC Teknoloji',
    description: 'ThreatLocker Türkiye çözümleri için ELC Teknoloji ile iletişime geçin. Zero Trust, Application Control, Allowlisting, Ringfencing ve endpoint güvenliği.',
    canonical: 'https://elcteknoloji.com/threatlocker-turkiye'
  },
  '/iletisim': {
    title: 'İletişim | ELC Teknoloji',
    description: 'ELC Teknoloji ile iletişime geçin. Adana, Ankara ve USA ofislerimiz. Siber güvenlik, Zebra ürünleri ve IT çözümleri için teklif alın.',
    canonical: 'https://elcteknoloji.com/iletisim'
  },
  '/gizlilik': {
    title: 'Gizlilik Politikası | ELC Teknoloji',
    description: 'ELC Teknoloji gizlilik politikası. Kişisel verilerinizin nasıl toplandığını, kullanıldığını ve korunduğunu öğrenin. KVKK uyumlu.',
    canonical: 'https://elcteknoloji.com/gizlilik'
  },
  '/privacy': {
    title: 'Privacy Policy | ELC Teknoloji',
    description: 'ELC Teknoloji privacy policy. Learn how your personal data is collected, used, and protected. GDPR compliant.',
    canonical: 'https://elcteknoloji.com/gizlilik'
  },
  '/kullanim-kosullari': {
    title: 'Kullanım Koşulları | ELC Teknoloji',
    description: 'ELC Teknoloji web sitesi kullanım koşulları. Siteyi kullanırken uymanız gereken kurallar ve yasal bilgiler.',
    canonical: 'https://elcteknoloji.com/kullanim-kosullari'
  },
  '/terms': {
    title: 'Terms of Service | ELC Teknoloji',
    description: 'ELC Teknoloji website terms of service. Rules and legal information you must follow when using the site.',
    canonical: 'https://elcteknoloji.com/kullanim-kosullari'
  }
};

export const SEOHead = () => {
  const location = useLocation();
  
  useEffect(() => {
    const path = location.pathname;
    const data = seoData[path] || seoData['/'];
    
    // Update title
    document.title = data.title;
    
    // Update meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', data.description);
    }
    
    // Update canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = data.canonical;
    
    // Update OG tags
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute('content', data.title);
    
    let ogDesc = document.querySelector('meta[property="og:description"]');
    if (!ogDesc) {
      ogDesc = document.createElement('meta');
      ogDesc.setAttribute('property', 'og:description');
      document.head.appendChild(ogDesc);
    }
    ogDesc.setAttribute('content', data.description);
    
    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (!ogUrl) {
      ogUrl = document.createElement('meta');
      ogUrl.setAttribute('property', 'og:url');
      document.head.appendChild(ogUrl);
    }
    ogUrl.setAttribute('content', data.canonical);
    
  }, [location.pathname]);
  
  return null;
};

export default SEOHead;
